import React, { useState, useEffect } from "react";
import Logo from "../img/logo.png";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa"; // ✅ добавили Telegram иконку

const ADDRESSES = [
  { coords: [56.845244, 53.222531], text: "г. Ижевск, ул. Ленина, д. 21 (ДЦ Форум), эт. 2, оф. 208/6" },
  { coords: [56.841039, 53.214895], text: "г. Ижевск, ул. Пушкинская, д. 173а" },
  { coords: [69.363519, 88.175358], text: "Красноярский край, г. Норильск, ул. Бегичева, д. 45" },
];

export const Contact = () => {
  const [consentChecked, setConsentChecked] = useState(false);
  const currentYear = new Date().getFullYear();

  const whatsappLink = "https://wa.me/79014576567";
  const telegramLink = "https://t.me/OpenCentr18"; // ✅ ссылка на Telegram

  useEffect(() => {
    if (window.ymaps) {
      window.ymaps.ready(() => {
        const container = document.getElementById("map");
        if (container && container.innerHTML !== "") container.innerHTML = "";

        const map = new window.ymaps.Map("map", {
          center: [62, 70],
          zoom: 4,
          controls: ["zoomControl", "fullscreenControl"],
        });

        ADDRESSES.forEach((addr) => {
          const pm = new window.ymaps.Placemark(addr.coords, { balloonContent: addr.text }, { preset: "islands#redDotIcon" });
          map.geoObjects.add(pm);
        });
        map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 50 });
      });
    }
  }, []);

  return (
    <footer id="contact" className="contact-section">
      <div className="container">
        <div
          className="contact-row"
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            right: "70px",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: "15px" }}>
            {/* Иконка WhatsApp */}
            <div className="whatsapp-icon">
              <FaWhatsapp />
            </div>

            {/* Основной блок */}
            <div style={{ maxWidth: "700px" }}>
              <div className="section-title text-left">
                <h2>Не оставайтесь одни с вашими переживаниями.</h2>
              </div>

              <div className="section-title text-left">
                <p>
                  Если вы чувствуете себя потерянным, нуждаетесь в поддержке – наши опытные психологи готовы помочь. Присоединяйтесь к тем, кто уже сделал первый шаг к лучшей жизни.
                </p>
              </div>

              <div className="section-title text-left">
                <p>Отправьте заявку на консультацию прямо сейчас!</p>
              </div>

              {/* Чекбокс */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
  <label style={{ fontSize: "14px", userSelect: "none", textAlign: "center" }}>
    <input
      type="checkbox"
      required
      checked={consentChecked}
      onChange={() => setConsentChecked(!consentChecked)}
      style={{ marginRight: "8px" }}
    />
    Я даю согласие на обработку{" "}
    <a
      href="/agreement"
      style={{ color: "#059a38", textDecoration: "underline" }}
      target="_blank"
      rel="noopener noreferrer"
    >
      персональных данных
    </a>
  </label>

  <p style={{ fontSize: "14px", marginTop: "5px", textAlign: "center" }}>
    <a
      href="/policy"
      style={{ color: "#059a38", textDecoration: "underline" }}
      target="_blank"
      rel="noopener noreferrer"
    >
      Политика конфиденциальности
    </a>
  </p>
</div>

{/* Кнопки WhatsApp и Telegram — по центру и вертикально */}
<div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    alignItems: "center",
    textAlign: "center",
  }}
>
  <button
    disabled={!consentChecked}
    onClick={() => window.open(whatsappLink, "_blank")}
    className="btn btn-custom btn-lg"
    style={{
      backgroundColor: "#25D366",
      borderColor: "#25D366",
      color: "#fff",
      cursor: consentChecked ? "pointer" : "not-allowed",
      minWidth: "200px",
    }}
  >
    <FaWhatsapp style={{ marginRight: "8px" }} />
    Написать в WhatsApp
  </button>

  <button
    disabled={!consentChecked}
    onClick={() => window.open(telegramLink, "_blank")}
    className="btn btn-custom btn-lg"
    style={{
      backgroundColor: "#0088cc",
      borderColor: "#0088cc",
      color: "#fff",
      cursor: consentChecked ? "pointer" : "not-allowed",
      minWidth: "200px",
    }}
  >
    <FaTelegramPlane style={{ marginRight: "8px" }} />
    Написать в Telegram
  </button>
</div>
            </div>
          </div>
        </div>

        {/* Карта */}
        <div className="contact-map">
          <div className="text-center">
            <h2>Мы находимся тут</h2>
          </div>
          <div id="map" style={{ height: "300px" }}></div>
        </div>

        {/* Футер */}
        <div className="footer-row" style={{ display: "flex", alignItems: "flex-start", marginTop: "60px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={Logo} alt="Логотип" style={{ width: "150px", height: "auto" }} />
          </div>
          <div style={{ marginLeft: "80px", display: "flex", flexDirection: "column", gap: "8px", fontSize: "16px" }}>
            <p style={{ margin: 0 }}>г. Ижевск, ул. Ленина, д. 21 (ДЦ Форум), эт. 2, оф. 208/6</p>
            <p style={{ margin: 0 }}>г. Ижевск, ул. Пушкинская, д. 173а</p>
            <p style={{ margin: 0 }}>Красноярский край, г. Норильск, ул. Бегичева, д. 45</p>
          </div>
          <div className="footer-phones">
            <p style={{ margin: 0 }}>
              <a href="tel:+79014576567">+7 (901) 457-65-67</a>
            </p>
            <p style={{ margin: 0 }}>
              <a href="tel:+73412476578">+7 (341) 247-65-78</a>
            </p>
          </div>
        </div>

        <div style={{ marginTop: "40px", textAlign: "center", fontSize: "14px", color: "#888" }}>
          <p style={{ margin: 0 }}>
            &copy; {currentYear} ООО «ЦЕНТР КОНСУЛЬТАЦИЙ». Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};
